import { useState } from 'react';

// Components
import { ButtonCustom, CheckBoxCustom, TextCustom } from '../../atoms';
import { DialogCustom } from '../../templates';
import { DialogActions, DialogContent } from '@mui/material';

// Constants
import { enfermedades } from './constant';
import { useCotizador } from '../../../hooks/others';

export const ModalPleniSalud = ({
  defaultValues = [],
  open = false,
  setOpen = () => null,
  aceptacionModal = () => null,
  setPreexistencias = () => null,
}) => {
  return (
    <DialogCustom
      open={open}
      setOpen={setOpen}
      title={'Declaración de padecimientos'}
      disabledDismiss
      className='p-0'
    >
      <DialogContent className="pt-0 px-0 md:px-6 fontPRegular p-0">
        <div className="relative my-5 w-auto  max-h-[863px] max-w-[977px] text-xs lg:text-sm px-4 lg:px-10">
          <PadecimientoSubTitulo
            texto={'Selecciona solo si padeces alguna de las siguientes enfermedades:'}
          />
          <PadecimientoLista
            defaultValues={defaultValues}
            setPreexistencias={setPreexistencias}
          />
          <PadecimientoTextoDeclaracion />
        </div>
      </DialogContent>
      <DialogActions>
        <PadecimientoButton aceptacionModal={aceptacionModal} />
      </DialogActions>
    </DialogCustom>
  );
};

const PadecimientoLista = ({
  defaultValues = [],
  setPreexistencias = () => null,
}) => {
  const { setDataCotizar } = useCotizador();

  const [selectedItems, setSelectedItems] = useState(defaultValues);

  const toggleSelection = codigo => {
    setSelectedItems(prev => {
      const newSelected = prev.includes(codigo)
        ? prev.filter(val => val !== codigo)
        : [...prev, codigo];

      setDataCotizar(prevState => ({
        ...prevState,
        valoresModales: {
          ...prevState.valoresModales,
          ENFPRE: newSelected,
        },
      }));
      setPreexistencias?.(newSelected);
      return newSelected;
    });
  };

  return (
    <div>
      <ol>
        <div className="grid grid-cols-1 pb-4 ">
          {enfermedades.map(({ codigo, nombre }) => (
            <li
              className="text-primary leading-5 sm:text-sm xsm:text-[15px] md:text-base 
              fontPRegular flex justify-between items-center odd:bg-[#F2F9FE] cursor-pointer pl-2 lg:pl-4 rounded-[8px]"
              key={codigo}
              onClick={() => toggleSelection(codigo)}
            >
              <TextCustom
                text={nombre}
                className="text-primary leading-5 sm:text-sm xsm:text-[15px] md:text-base items-center fontPRegular"
              />

              <CheckBoxCustom
                value={selectedItems.includes(codigo)}
              />
            </li>
          ))}
        </div>
      </ol>
    </div>
  );
};

const PadecimientoSubTitulo = ({ texto = '' }) => {
  return (
    <div className="grid grid-cols-1 pb-[21px]">
      <TextCustom
        text={texto}
        className="text-primary text-center md:text-left leading-5 sm:text-sm xsm:text-[15px] md:text-base items-center fontPSemiBold"
      />
    </div>
  );
};

const PadecimientoTextoDeclaracion = () => {
  return (
    <div className=" border-t border-[#DDDDDD] pt-[26px] ">
      <TextCustom
        text="Declaro que, si padezco alguna de las enfermedades anteriores, los gastos relacionados no estarán cubiertos. Además, en caso de un siniestro, 
      autorizo al INS a revisar mi historial médico para confirmar 
      si la enfermedad existía antes de la emisión de esta póliza. Si se confirma que es preexistente, el INS no asumirá el pago."
        className=" fontPRegular text-primary flex text-center"
      />
    </div>
  );
};

const PadecimientoButton = ({ aceptacionModal = () => null }) => {
  return (
    <div className="flex justify-center w-full pb-9">
      <ButtonCustom
        text="Confirmar"
        typeColor="primary"
        onClick={() => aceptacionModal(true)}
        width={'150px'}
        height={'45px'}
        className="text-xs sm:text-sm xsm:text-[15px] md:text-base"
      />
    </div>
  );
};
